import React, { FC, isValidElement, ReactElement, ReactNode } from "react";
import classNames from "classnames";

import { uiConstants } from "../../../constants";
import { SimpleAction } from "../../../types/GlobalTypes";
import { Button } from "../Button";

type Props = {
  heading: ReactNode;
  children: ReactNode;
  className?: string;
  action?: SimpleAction | ReactElement;
  dataTest?: string;
};

export const AttentionBanner: FC<Props> = ({
  heading,
  children,
  className,
  action,
  dataTest,
}) => {
  return (
    <div
      className={classNames(
        "flex flex-col gap-4 pt-4 pb-10 px-4 w-full h-full",
        uiConstants.attention.backgroundColor,
        className,
        "rounded-lg",
        action && !isValidElement(action) ? "cursor-pointer" : "cursor-default"
      )}
      data-test={dataTest}
      onClick={
        action && !isValidElement(action)
          ? (action as SimpleAction).onClick
          : undefined
      }
    >
      <div
        className="font-poppins text-xl font-bold"
        data-test={`${dataTest}-heading`}
      >
        {heading}
      </div>

      <div
        className="flex flex-col justify-between h-full"
        data-test={`${dataTest}-content`}
      >
        {children}
      </div>

      {action && (
        <div>
          {isValidElement(action) ? (
            (action as ReactElement)
          ) : (
            <Button
              onClick={(action as SimpleAction).onClick}
              dataTest={`${dataTest}-action`}
              variant={Button.variant.TEMPTING}
            >
              {(action as SimpleAction).label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
